<template>
  <v-app id="inspire">
    <snackbar></snackbar>
    <v-navigation-drawer v-model="drawer" app v-if="isAuthenticated">
      <v-list dense>
        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('Home_Menu') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              <router-link :to="{ name: 'PartyList' }">{{ $t('Parties_Menu') }}</router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
          <v-list-item>
              <v-list-item-action>
                  <v-icon>mdi-bank-transfer-out</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                  <v-list-item-title>
                      <router-link :to="{ name: 'CreditTransferList' }">{{ $t('CreditTransfers_Menu') }}</router-link>
                  </v-list-item-title>
              </v-list-item-content>
          </v-list-item>
          <v-list-item>
              <v-list-item-action>
                  <v-icon>mdi-book-open-page-variant</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                  <v-list-item-title>
                      <router-link :to="{ name: 'CreditTransferPaymentRunList' }">{{ $t('CreditTransferPaymentRuns_Menu') }}</router-link>
                  </v-list-item-title>
              </v-list-item-content>
          </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Zahllauf</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="isAuthenticated && ! isLoggingIn" @click="logoutAndRedirect">{{ $t('Logout') }}</v-btn>
        <v-btn v-else-if=" ! isLoggingIn" @click="login" color="error">{{ $t('Login') }}</v-btn>
    </v-app-bar>

    <v-content>
      <Breadcrumb layout-class="pl-3 py-3" />
        <v-scroll-y-reverse-transition hide-on-leave>
            <router-view></router-view>
        </v-scroll-y-reverse-transition>
    </v-content>
    <v-footer app>
      <span class="white--text">&copy; 2019</span>
    </v-footer>
  </v-app>
</template>

<script>
import Breadcrumb from './components/Breadcrumb';
import Snackbar from './components/Snackbar';
import { mapGetters, mapActions } from 'vuex';
import security from "./services/security";

export default {
    components: {
        Breadcrumb,
        Snackbar
    },

    data: () => ({
        drawer: null
    }),

    computed: {
        ...mapGetters('security', ['isAuthenticated', 'isLoggingIn'])
    },

    methods: {
        ...mapActions('security', ['logout']),
        login() {
            window.location.href = security.buildLoginUrl().toString();
        },
        logoutAndRedirect() {
            this.logout().then(() => {
                this.$router.push({ name: 'Login' });
            })
        }
    }

};
</script>
